import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaTrophy, FaUsers, FaCalendarCheck, FaMedal, FaArrowRight } from 'react-icons/fa';
import './About.css';
import { Helmet } from 'react-helmet';

const ProfessionalCoaching = () => {

    return (
        <>
            <Helmet>
                <title>Professional Coaching</title>
            </Helmet>
            <div className="about-page">
                <div className="page-header">
                    <div className="container">
                        <h1>Professional Coachoing</h1>
                        <div className="breadcrumb">
                            <Link to="/">Home</Link>
                            <span>/</span>
                            <span>Intermediate Coaching</span>
                        </div>
                    </div>
                </div>

                <section className="about-intro section">
                    <div className="container">
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <span className="section-subtitle">Imperial Badminton Academy</span>
                                <h2>Professional Coaching</h2>
                                <p>
                                    At Imperial Badminton Academy, our Professional Coaching program is designed to deliver high-level, systematic, and results-oriented badminton training. This program is led by experienced and certified coaches who focus on technical excellence, tactical intelligence, physical conditioning, and mental resilience required for competitive and professional badminton.
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="intro-img-main">
                                    <img src="/img/Professional Coachoing.jpg" alt="Academy Training" />
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>What Is Professional Coaching?</h3>
                                <p>
                                    Professional coaching goes beyond basic training. It involves in-depth skill analysis, advanced techniques, match strategies, fitness conditioning, and continuous performance evaluation. Our coaching approach is tailored to help players achieve consistency, confidence, and competitive readiness at higher levels.
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Expert & Certified Coaches</h3>
                                    <p>
                                        Correct and advanced techniques
                                        <br></br>
                                        Individual player development
                                        <br></br>
                                        Match strategy and tactical awareness
                                        <br></br>
                                        Long-term performance improvement
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Personalized Coaching Approach</h3>
                                <p>
                                    We understand that every player has unique strengths and areas for improvement. Our professional coaching program includes personalized training plans designed according to individual skill level, fitness capacity, and performance goals.
                                    <br></br>
                                    Players receive regular feedback and one-on-one guidance to refine their game effectively.
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Advanced Technical Training</h3>
                                    <p>Precision smash and shot placement
                                        <br></br>
                                        Deceptive strokes and net control
                                        <br></br>
                                        Defensive techniques and counter-attacks
                                        <br></br>
                                        Efficient footwork and recovery</p>
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Tactical & Match Strategy Development</h3>
                                <p>
                                    Rally construction
                                    <br></br>
                                    Court positioning
                                    <br></br>
                                    Singles and doubles tactics
                                    <br></br>
                                    In-match decision making
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Fitness & Performance Conditioning</h3>
                                    <p>Strength and power training
                                        <br></br>
                                        Speed and agility enhancement
                                        <br></br>
                                        Endurance and stamina building
                                        <br></br>
                                        Injury prevention and recovery</p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Mental Conditioning & Competitive Mindset</h3>
                                    <p>Handle match pressure confidently
                                        <br></br>
                                        Maintain focus and composure
                                        <br></br>
                                        Build self-belief and resilience
                                        <br></br>
                                        Perform consistently under stress</p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Match Practice & Performance Evaluation</h3>
                                    <p>Regular match simulations and competitive practice sessions help players apply training in real match situations. Coaches analyze performance and provide constructive feedback to improve consistency and match awareness.
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Tournament Preparation & Career Guidance</h3>
                                    <p>Imperial Badminton Academy offers complete support for tournament preparation, including training schedules, recovery planning, and competition strategies. Players receive guidance for participation in district, state, national, and professional tournaments.
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Benefits of Professional Coaching at Imperial Badminton Academy</h3>
                                    <p>Elite-level coaching and guidance
                                        <br></br>
                                        Personalized training programs
                                        <br></br>
                                        Professional match readiness
                                        <br></br>
                                        Improved physical and mental performance
                                        <br></br>
                                        Clear pathway toward competitive excellence
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Train Like a Professional</h3>
                                    <p>Professional Coaching at Imperial Badminton Academy is ideal for dedicated players who aspire to compete at higher levels and achieve excellence. With expert guidance, disciplined training, and a performance-focused environment, players are prepared to succeed in competitive badminton.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default ProfessionalCoaching;
